import React, { useEffect, useState } from 'react';
import { CartContainer } from '../style';
import minus from '@design-system/Assets/minus.svg';
import add from '@design-system/Assets/add.svg';
import deleteIcon from '@design-system/Assets/delete.svg';
import PropTypes from 'prop-types';
import commaNumber from 'comma-number';
import { Link } from 'react-router-dom';

const Cart = ({ cart, onClick, updateQuantitys }) => {
  const [quantity, setQuantity] = useState(0);
  const token = localStorage.getItem('x-access-token');
  useEffect(() => {
    if (cart) {
      setQuantity(cart?.quantity);
    }
  }, [cart]);

  const updateQuantity = (type, indx) => {
    let newQuantity = quantity;
    if (type == 'Increment') {
      newQuantity += 1;
    } else {
      if (quantity === 1) return;
      newQuantity -= 1;
    }
    setQuantity(newQuantity);
    if (token) {
      let data = {
        quantity: newQuantity,
        size: cart.size,
        product: cart.product._id,
      };
      updateQuantitys(indx, data);
    } else {
      updateQuantitys(indx, newQuantity);
    }
  };

  return (
    <>
      <CartContainer>
        <img src={cart?.image || cart?.product?.image} className="image" />

        <div style={{ width: '100%' }}>
          {/* info */}
          <div className="info">
            {/* name and weight */}
            <div>
              <Link to={`/products/${cart?._id}`} style={{ textDecoration: 'none' }}>
                {' '}
                <h4>{cart?.name || cart?.product?.name}</h4>
              </Link>

              <h5>
                {cart?.size} {cart?.unit || cart?.product?.unit}{' '}
              </h5>
            </div>
            {/* name and weight end */}

            {/* quantity */}
            <div>
              <h6>Quantity</h6>
              <div className="quantity_box">
                <div className="content">
                  <img
                    src={minus}
                    alt="minus"
                    style={{ cursor: 'pointer' }}
                    onClick={() => updateQuantity('decrement', cart?._id)}
                  />
                  <input type="text" value={quantity} readOnly />
                  <img
                    src={add}
                    alt="add"
                    style={{ cursor: 'pointer' }}
                    onClick={() => updateQuantity('Increment', cart?._id)}
                  />
                </div>
              </div>
            </div>
            {/* quantity end */}
          </div>
          {/* info end */}

          {/* price and delete */}

          <div className="sub_info">
            <h3>
              {' '}
              {token
                ? `${cart?.price?.currency?.symbol}${commaNumber(
                    cart?.price?.value,
                  )}`
                : `${cart?.price?.currency?.symbol}${commaNumber(
                    cart?.price?.value * cart?.quantity,
                  )}`}
            </h3>
            <div className="delete" onClick={onClick}>
              <img src={deleteIcon} alt="delete-icon" />
              Delete
            </div>
          </div>
          {/* price and delete */}
        </div>
      </CartContainer>
    </>
  );
};

export default Cart;

Cart.propTypes = {
  cart: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  updateQuantitys: PropTypes.func.isRequired,
};

Cart.defaultProps = {
  onClick: () => {},
};
